// extracted by mini-css-extract-plugin
export var carrierTab = "_4d-0";
export var carrierTabActive = "_4d-1 _4d-0";
export var carrierTabInactive = "_4d-2 _4d-0";
export var carrierTabLabel = "_4d-3";
export var carrierTabLabelActive = "_4d-4 _4d-3";
export var carrierTabLabelInactive = "_4d-5 _4d-3";
export var carrierTabPercentage = "_4d-6";
export var carrierTabPercentageActive = "_4d-7 _4d-6";
export var carrierTabPercentageInactive = "_4d-8 _4d-6";
export var carrierTabWinnable = "_4d-9";
export var carrierTabWinnableActive = "_4d-a _4d-9";
export var carrierTabWinnableInactive = "_4d-b _4d-9";
export var comparisonContainer = "_4d-d";
export var missingRateButton = "_4d-n";
export var missingRateButtonActive = "_4d-o _4d-n";
export var missingRateButtonInactive = "_4d-p _4d-n";
export var missingRateButtonLabel = "_4d-q";
export var missingRateButtonLabelActive = "_4d-r _4d-q";
export var missingRateButtonLabelInactive = "_4d-s _4d-q";
export var sidebar = "_4d-c";
export var strategyButton = "_4d-e";
export var strategyButtonActive = "_4d-f _4d-e";
export var strategyButtonDescription = "_4d-k";
export var strategyButtonDescriptionActive = "_4d-l _4d-k";
export var strategyButtonDescriptionInactive = "_4d-m _4d-k";
export var strategyButtonInactive = "_4d-g _4d-e";
export var strategyButtonLabel = "_4d-h";
export var strategyButtonLabelActive = "_4d-i _4d-h";
export var strategyButtonLabelInactive = "_4d-j _4d-h";
export var unitToggleButton = "_4d-t";
export var unitToggleButtonActive = "_4d-u _4d-t";
export var unitToggleButtonInactive = "_4d-v _4d-t";
export var unitToggleButtonLabel = "_4d-w";
export var unitToggleButtonLabelActive = "_4d-x _4d-w";
export var unitToggleButtonLabelInactive = "_4d-y _4d-w";